<template>
  <div class="container is-fluid">
    <div class="columns">
	    <div class="column">
	    	<div class="card ">
			  <header class="card-header">
			    <p class="card-header-title">
			      Order Details
			    </p>
			    <a href="#" class="card-header-icon" aria-label="more options">
			      <span class="icon">
			        <i class="fas fa-angle-down" aria-hidden="true"></i>
			      </span>
			    </a>
			  </header>
			  <div class="card-content">
			    <div class="content">
			      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.
			      <a href="#">@bulmaio</a>. <a href="#">#css</a> <a href="#">#responsive</a>
			      <br>
			      <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
			    </div>
			  </div>
			  <footer class="card-footer">
			    <a href="#" class="card-footer-item">Save</a>
			    <a href="#" class="card-footer-item">Edit</a>
			    <a href="#" class="card-footer-item">Delete</a>
			  </footer>
			</div>
		</div>
		
		<div class="column">
		 <div class="card ">
		  <header class="card-header">
		    <p class="card-header-title">
		      Order Details
		    </p>
		    <a href="#" class="card-header-icon" aria-label="more options">
		      <span class="icon">
		        <i class="fas fa-angle-down" aria-hidden="true"></i>
		      </span>
		    </a>
		  </header>
		  <div class="card-content">
		    <div class="content">
		      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.
		      <a href="#">@bulmaio</a>. <a href="#">#css</a> <a href="#">#responsive</a>
		      <br>
		      <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
		    </div>
		  </div>
		  <footer class="card-footer">
		    <a href="#" class="card-footer-item">Save</a>
		    <a href="#" class="card-footer-item">Edit</a>
		    <a href="#" class="card-footer-item">Delete</a>
		  </footer>
		</div>
	    </div>
    	</div>
  </div>
</template>

<script>

//import Buttons from '@/components/Buttons';
import OrderService from '@/services/OrderService.js';

export default {
  //components: {
  // 	Buttons
  //},
  data() {
    return {
      orders: [],
      errors: []
     
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    //this.getOrderData();
    
   
  },
  methods: {
  	
    async getOrderData() {
      const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
      OrderService.getOrders(accessToken)
      .then(
        (orders => {
          this.$set(this, "orders", orders);
        }).bind(this)
      );
    }
  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"
</script>

<style>
	
</style>
